// extracted by mini-css-extract-plugin
module.exports = {"container":"de","disabled":"ee","bgBlack":"fe","content":"ge","countdown":"he","topCaption":"ie","topHeading":"je","heading":"ke","copy":"le"};